/**
 * Get a flat list of services for dropdowns from salon profile.servicesData
 * servicesData may have: basicServices[], serviceCategories[], combos[]
 * Each service: { name, price?, duration? }
 * @param {Object} profile - salonData.profile
 * @returns {Array<{ label: string, name: string, price: number }>}
 */
export function getServicesListFromProfile(profile) {
  const list = [];
  if (!profile?.servicesData) return list;

  const sd = profile.servicesData;

  if (Array.isArray(sd.basicServices)) {
    sd.basicServices.forEach((s) => {
      const name = s.name || 'Unnamed';
      const price = Number(s.price) || 0;
      list.push({ label: `${name}${price ? ` - ₹${price}` : ''}`, name, price });
    });
  }

  if (Array.isArray(sd.serviceCategories)) {
    sd.serviceCategories.forEach((cat) => {
      const services = cat.services || cat.serviceList || [];
      services.forEach((s) => {
        if (Array.isArray(s.subServices) && s.subServices.length) {
          // Nested subservices carry the price; parent is only a grouping
          s.subServices.forEach((sub) => {
            const name = `${s.name || 'Unnamed'} - ${sub.name || 'Unnamed'}`;
            const price = Number(sub.price) || 0;
            list.push({ label: `${name}${price ? ` - ₹${price}` : ''}`, name, price });
          });
          return;
        }
        const name = s.name || 'Unnamed';
        const price = Number(s.price) || 0;
        list.push({ label: `${name}${price ? ` - ₹${price}` : ''}`, name, price });
      });
    });
  }

  if (Array.isArray(sd.combos)) {
    sd.combos.forEach((c) => {
      const name = c.name || 'Unnamed Combo';
      const price = Number(c.price) || 0;
      list.push({ label: `${name}${price ? ` - ₹${price}` : ''} (Combo)`, name, price });
    });
  }

  return list;
}
